import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import QuestionPicker from '../picker/QuestionPicker'

const QuestionsFilter = ({ field, ...props }) => {
  const { t } = useTranslation('questions')
  field = field || 'questionIds'
  const label = t('questions')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <QuestionPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default QuestionsFilter
